export const GET_COLORS = "getColors";
export const CHANGE_MODE = "changeRenderMode";
export const API_FAIL = "colorSelector/API_FAIL";
